import MagicLinkForm from 'profile/login/forms/MagicLinkForm';

const MagicLinkForms = () => (
  <div className="c7-account-login--returning-customer">
    <h4>Magic Link</h4>
    <MagicLinkForm
      redirectLink="/reservation/checkout/checkout"
      loginLink="/reservation/checkout/login"
    />
  </div>
);

export default MagicLinkForms;
